export const workOrderEndpoints = {
  // SERV-3236: whether the caller may create work orders for a client.
  canCreateForClient: (clientId: string) => `/work-order/clients/${clientId}/can-create`,
  getWorkOrderHeaderData: "/work-order/header",
  getWorkOrderOverview: "/work-order",
  //Visit
  getVisitTypes: "/visit/types",
  getVisitTrades: "/visit/trades",
  addVisit: "/visit/create",
  updateVisit: "/visit",
  //LocationInfo
  getLocationInfo: "/work-order/location-info",
  // Weather API - Open-Meteo (free, no API key)
  getOpenMeteoForecast: "https://api.open-meteo.com/v1/forecast",
  getOpenMeteoArchive: "https://archive-api.open-meteo.com/v1/archive",
  // Weather API - Google Weather API
  getGoogleWeatherForecast: "https://weather.googleapis.com/v1/forecast/days:lookup",

  getWorkOrderNotes: "/work-order",
  createWONote: "/work-order",
  updateWONote: "/work-order",
  getWorkOrderOverviewVisits: "/visit/list",
  getUpcomingVisitInOverview: "/visit/upcoming",
  getDispatcherDropdownData: "/user-management/user-roles",
  updateWorkOrderDispatcher: "/work-order",
  getVisitDetail: "/visit/detail",
  externalCheckQueue: "/visit/external-check-queue",
  externalCheckFilterOptions: "/visit/external-check-queue/filter-options",
  externalCheckDetails: "/visit",
  getVisitTimeline: "/visit",
  updateVisitAttendance: "/visit",
  getVisitAssessment: "/visit",
  updateVisitAssessment: "/visit",
  updateVisitExpectedDates: "/visit",
  updateVisitStatus: "/visit/status",
  getDropdown: "/dropdown",

  dropdown: "/dropdown",
  workOrderAddresses: "/dropdown/work-order-addresses",
  workOrderNumbers: "/dropdown/work-order-numbers",
  workOrderFilter: "/dropdown/work-order-filter",

  editWorkOrder: "/work-order",
  getWorkOrderById: "/work-order",
  /** Base path for marking work order as arrived (PUT /work-orders/:workOrderId/arrived) */
  markWorkOrderArrived: "/work-order",
  travelDelayOptions: "/dropdown/lookups?type=travel_delay_option",
  spDelayReasonOptions: "/dropdown/lookups?type=sp_delay_reason",
  rescheduleWorkOrder: "/work-order",
  cancelWorkOrder: "/work-order",
  markWorkOrderEnRoute: "/work-order",
  delayWorkOrder: "/work-order",
  // acceptWorkOrder: "/auto-dispatch/response",
  acceptWorkOrder: (workOrderId: string) => `/work-order/${workOrderId}/response`,
  spcompanionList: "/service-providers/companions",
  companionFrequencyOptions: "/dropdown/lookups?type=how_often_accompanies",
  companionLaborOptions: "/dropdown/lookups?type=how_much_assistance",
  quickAddBrand: "/client/quick-add/newBrand",
  quickAddLocation: "/client/quick-add/newLocation",
  quickAddClient: "/client/quick-add/newClient",
  geographyStates: "/geography/states",
  geographyCities: "/geography/states",
  validateAddress: "/geography/validate-address",
  workOrderDetails: "/work-order/details",
  getProposalList: "/proposal/list",
  getProposalDetail: "/proposal",
  createProposal: "/proposal/create",
  suggestProposalName: "/proposal/suggest-name",
  duplicateProposal: "/proposal/duplicate",
  createDispatcherFilledAssessment: "/assessment/dispatcher-filled",
  getSpAssessments: "/proposal/assessments",
  getProposalVisitForms: "/proposal/visit-forms",
  generateProposal: "/proposal/generate",
  closeProposalForIncurred: "/proposal/close-for-incurred",
  updateProposalStatus: "/proposal",
  proposalApproverCandidates: "/proposal",
} as const;
